import { observer } from "mobx-react-lite"
import { ActiveUpload, UploadStatus } from "./FileUploadStore"
import DescriptionIcon from '@mui/icons-material/DescriptionOutlined'
import Box from "@mui/material/Box"
import { fileIsAGapImage } from "reusable/utils/file-operations"
import CircularProgress from "@mui/material/CircularProgress"
import FailedIcon from "@mui/icons-material/PriorityHigh"
import Avatar from "@mui/material/Avatar"
import { useTheme } from "theme/useTheme"

export default observer(function FileUploadBlockIcon({ uploadedFile }: { uploadedFile: ActiveUpload }) {
   const isImage = fileIsAGapImage(uploadedFile.file)
   const theme = useTheme()

   if ([UploadStatus.failed, UploadStatus.invalid].includes(uploadedFile.status)) {
      return <Box sx={{ width: '120px', display: "flex", flexDirection: "row", justifyContent: "center" }}>
         <Avatar sx={{ backgroundColor: '#3314351F' }}>
            <FailedIcon color="primary" />
         </Avatar>
      </Box>
   }

   if (isImage && uploadedFile.imgUrl !== undefined) {
      return <Box sx={{
         width: '120px',
         height: '120px',
         textAlign: 'center',
         display: "flex",
         flexDirection: "column",
         justifyContent: "center"
      }}>
         {uploadedFile.imgUrl === "" && <CircularProgress sx={{ ml: '40px' }} />}
         {uploadedFile.imgUrl !== "" && <Box
            component="img"
            sx={{
               maxHeight: '120px',
               maxWidth: '120px',
            }}
            alt="Uploaded image"
            src={uploadedFile.imgUrl}
         />}
      </Box>
   }

   return <DescriptionIcon sx={{ width: '42px', height: '42px', color: theme.palette.gap.primary['600'] }} />
})
